import { render, staticRenderFns } from "./spaceSetting.vue?vue&type=template&id=3622923c&scoped=true&"
import script from "./spaceSetting.vue?vue&type=script&lang=js&"
export * from "./spaceSetting.vue?vue&type=script&lang=js&"
import style0 from "./spaceSetting.vue?vue&type=style&index=0&id=3622923c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3622923c",
  null
  
)

component.options.__file = "spaceSetting.vue"
export default component.exports